import { ROUND_PARAMS } from '../portals/utils';

export default {
  methods: {
    // if changing need to update logic in mpower-api/src/lib/parts.js
    marginChanged(obj, keys = ['unitPrice', 'unitCost', 'margin'], toFixed = 3) {
      const margin = parseFloat(obj[keys[2]]);
      const unitCost = parseFloat(obj[keys[1]]);
      const unitPrice = parseFloat(obj[keys[0]]);
      if (margin) {
        if (unitCost) {
          const unitPrice = parseFloat((unitCost / (1 - margin / 100)).roundCeil(ROUND_PARAMS.PRICE));
          this.$set(obj, keys[0], unitPrice);
        } else if (unitPrice) {
          const unitCost = parseFloat((unitPrice * (1 - margin / 100)).roundCeil(toFixed));
          this.$set(obj, keys[1], unitCost);
        }

        if (obj.unitPrice) {
          const isEmptyPrice = typeof obj.price === 'undefined' || obj.price === '';
          const price = isEmptyPrice ? obj.unitPrice : Math.min(+obj.price, +obj.unitPrice);
          this.$set(obj, 'price', price);
        }
        this.formatFloats(obj, keys, true);
      }
    },
    // if changing need to update logic in mpower-api/src/lib/parts.js
    priceChanged(obj, keys = ['margin', 'unitCost', 'unitPrice']) {
      const unitPrice = parseFloat(obj[keys[2]]);
      const unitCost = parseFloat(obj[keys[1]]);
      const margin = parseFloat(obj[keys[0]]);
      if (!isNaN(unitPrice) && !isNaN(unitCost) && unitPrice !== 0) {
        this.$set(obj, keys[0], (((unitPrice - unitCost) / unitPrice) * 100).roundCeil(ROUND_PARAMS.MARGIN));
      } else if (unitPrice && margin) {
        const unitCost = parseFloat((unitPrice * (1 - margin / 100)).roundCeil(ROUND_PARAMS.COST));
        this.$set(obj, keys[1], unitCost);
      }
      if (obj.unitPrice) {
        const isEmptyPrice = typeof obj.price === 'undefined' || obj.price === '';
        const price = isEmptyPrice ? obj.unitPrice : Math.min(+obj.price, +obj.unitPrice);
        this.$set(obj, 'price', price);
      }
      this.formatFloats(obj, keys, true);
    }
  }
};
